import React from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import SglContext from "../SglContext";
import ClassResult from "../classes/classResult";
import '../classes/classes.css';
export default class ResultDetail extends React.Component {
  state = {
    channel: 1,
    division: {},
    entries: [],
    classes: [],
    points_data: {},
    show_name: "",
    default_tab: "entries",
    current_tab: "placings",
    current_show: this.getQueryVariable("sid"),
    userData: {},
    videos_list: [],
    is_videos_enabled: false,
    video_to_play: {},
    playing_video: false,
    is_open_play_video_modal: false,
    is_open_do_subscription_modal: false,
    is_admin: false,
    loading: true,
    flag_img_dir: this.importAll(
      require.context("../images/Flags/Large", false, /\.(png|jpe?g|svg)$/)
    ),
    ip_address: "",
  };
  constructor() {
    super();
    this.VideoPlayerElement = React.createRef();
    this.VideoSubscriptionElement = React.createRef();

    this.openSection = this.openSection.bind(this);
    this.closeModal = this.closeModal.bind(this);
    this.closeSubscriptionModal = this.closeSubscriptionModal.bind(this);
    this.playVideoAfterSubscribe = this.playVideoAfterSubscribe.bind(this);
  }
  componentDidMount() {
    this.getResultDetails(this.state.channel);
  }

  importAll(r) {
    let images = {};
    r.keys().map((item, index) => {
      images[item.replace("./", "")] = r(item);
    });
    return images;
  }

  getQueryVariable(variable) {
    var query = window.location.search.substring(1);
    var vars = query.split("&");
    for (var i = 0; i < vars.length; i++) {
      var pair = vars[i].split("=");
      if (pair[0] == variable) {
        return pair[1];
      }
    }
    return false;
  }

  async getResultDetails(channel) {
    this.getUserData();
    this.getClassVideos();
    await axios
      .all([
        await axios.get(
          this.context.nestApiUrl +
            "/results/" +
            this.getQueryVariable("div_id"),
          {
            params: {
              show_id: this.getQueryVariable("sid"),
              customer_id: this.context.company_id,
              channel: channel,
            },
          }
        )
      ])
      .then(
        axios.spread((res) => {
          this.setState({
            division: res.data.division,
            entries: res.data.entries,
            classes: res.data.classes,
            channel: res.data.channel,
            show_name: res.data.show_name,
            points_data: res.data.points_data,
            current_show: res.data.show_id,
            is_videos_enabled: res.data.is_videos_enabled,
            loading: false,
          });
          document.title = 'Results for ' +
            res.data.division.name + " - " + res.data.show_name;
          this.context.reportToGA(
            "/sgl-wp-plugin/" +
              this.context.company_urlpath +
              "/" +
              this.getQueryVariable("sid") +
              "/results/detail/divisions/" +
              this.getQueryVariable("div_id")
          );
          this.context.reportToFB(
            "/sgl-wp-plugin/" +
              this.context.company_urlpath +
              "/" +
              this.getQueryVariable("sid") +
              "/results/detail/divisions/" +
              this.getQueryVariable("div_id")
          );
        })
      );
  }
  async getClassVideos() {
    await axios
      .get(
        this.context.nestApiUrl +
          "/results/" +
          "videos/" +
          this.getQueryVariable("div_id"),
        {
          params: {
            show_id: this.getQueryVariable("sid"),
            customer_id: this.context.company_id,
          },
        }
      )
      .then((res) => {
        this.setState({
          videos_list: res.data.class_videos,
        });
      });
  }
  async getUserData() {
    await axios.get(this.context.nestApiUrl + "/users/getUser").then(
      (response) => {
        if (response.data.user && response.data.user != null) {
          this.setState({
            userData: response.data.user,
          });
          if (
            localStorage.getItem("playing_video_id") &&
            localStorage.getItem("playing_video_url") ==
              window.location.pathname.replace(this.context.basePath, '') + window.location.search
          ) {
            this.playVideoAPICall(localStorage.getItem("playing_video_id"));
          }
        } else {
        }
      },
      (error) => {}
    );
  }
  playVideo = (video_id) => (e) => {
    this.playVideoAPICall(video_id);
  };
  playVideoAPICall(video_id) {
    localStorage.setItem("playing_video_id", video_id);
    localStorage.setItem("playing_video_url", window.location.pathname.replace(this.context.basePath, '') + window.location.search);
    axios
      .get(this.context.nestApiUrl + "/videos/play/" + video_id, {
        params: {
          // show_id: this.getQueryVariable("sid"),
          customer_id: this.context.company_id,
        },
      })
      .then((res) => {
        this.closeSubscriptionModal();
        localStorage.removeItem("playing_video_id");
        localStorage.removeItem("playing_video_url");
        if (res.data.subscribed_to_play) {
          this.setState({
            video_to_play: res.data.video,
            is_admin: res.data.is_admin,
            is_open_play_video_modal: true,
            playing_video: true,
          });
        } else {
          this.setState({
            video_to_play: res.data.video,
            is_admin: res.data.is_admin,
            is_open_do_subscription_modal: true,
            playing_video: true,
          });
        }
      });
  }

  closeModal() {
    this.setState({
      is_open_play_video_modal: false,
      playing_video: false,
    });
  }
  closeSubscriptionModal() {
    this.setState({
      is_open_do_subscription_modal: false,
      playing_video: false,
    });
  }
  playVideoAfterSubscribe() {
    this.playVideoAPICall(this.state.video_to_play.videos_sgl_id);
    this.setState({
      playing_video: true,
    });
  }

  getVideoTitle(video) {
    if (video["class_type"] == "Jumpers") {
      if (video["trip_type"].toLowerCase() != "jo") {
        return " - Round 1";
      } else {
        return " - Jump Off";
      }
    }
  }

  openTab = (tabName) => (e) => {
    this.setState({ current_tab: tabName });
  };

  openSection = (split) => (e) => {
    var i, all_sections, selected_section, sectionLink;
    selected_section = document.getElementsByClassName("split_" + split);
    all_sections = document.getElementsByClassName("section");
    for (i = 0; i < all_sections.length; i++) {
      all_sections[i].style.display = "none";
    }

    for (i = 0; i < selected_section.length; i++) {
      selected_section[i].style.display = "table-row";
    }
    sectionLink = document.getElementsByClassName("sectionLink");
    for (i = 0; i < sectionLink.length; i++) {
      sectionLink[i].className = sectionLink[i].className.replace(
        " active",
        ""
      );
    }
    e.currentTarget.className += " active";
  };

  getFaultTime(
    time_faults,
    faults,
    time,
    round_no,
    placing,
    jumper_table_info
  ) {
    var JOQualified = false;

    if (jumper_table_info && jumper_table_info.hasJO) {
      if (time_faults) {
        JOQualified = false;
      } else {
        JOQualified = true;
      }
    }

    var hasPlacing = placing > 0 && placing != 100000;
    var hasJOScore = hasPlacing && JOQualified;

    var total_faults = time_faults + faults;
    if (time > 0) {
      var time_string = time.toString();
      if (jumper_table_info && jumper_table_info.fei_rule) {
        time = time_string.slice(0, time_string.indexOf(".") + 3);
      } else {
        time = time_string.slice(0, time_string.indexOf(".") + 4);
      }
      return total_faults + " | " + time;
    } else {
      if ((round_no == 1 && hasPlacing) || (round_no == 2 && hasJOScore)) {
        return "N/A";
      } else {
        return " - ";
      }
    }
  }

  format_currancy(amount) {
    return (
      "$" + (amount && amount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","))
    );
  }

  getJudges(div_class) {
    var judges = [];

    for (var i = 0; i < div_class.class_related_data.judges.length; i++) {
      var judge_name = "";
      if (div_class.class_related_data.judges[i].name) {
        if (div_class.class_related_data.judges[i].position) {
          judge_name = div_class.class_related_data.judges[i].position + ": ";
        }
        judge_name += div_class.class_related_data.judges[i].name.replace(
          ",",
          " "
        );
      }
      judges.push(judge_name);
    }
    return judges.join(", ");
  }

  getHeadUsingForLoop = (entry) => {
    const array = [];

    for (var i = 0; i < entry.over_fence_class_points.length; i++) {
      array.push(
        <th className='center-align'>
          <Link
            className='sgl-a-force'
            to={
              "/classes/detail?cid=" +
              entry.over_fence_class_points[i]["class_id"] +
              "&sid=" +
              this.getQueryVariable("sid")
            }>
            {entry.over_fence_class_points[i]["class_number"]}
          </Link>
        </th>
      );
    }
    if (this.state.points_data.us_flag) {
      array.push(<th className='center-align'>Over Fences</th>);
      for (var i = 0; i < entry.under_saddle_class_points.length; i++) {
        array.push(
          <th className='center-align'>
            <Link
              className='sgl-a-force'
              to={
                "/classes/detail?cid=" +
                entry.under_saddle_class_points[i]["class_id"] +
                "&sid=" +
                this.getQueryVariable("sid")
              }>
              {entry.under_saddle_class_points[i]["class_number"]}
            </Link>
          </th>
        );
      }
    }
    return array;
  };

  getPointsDataUsingForLoop = (entry) => {
    const array = [];

    for (var i = 0; i < entry.over_fence_class_points.length; i++) {
      array.push(
        <td className='center-align'>
          <a>
            {entry.over_fence_class_points[i]["points"] == 0
              ? "-"
              : entry.over_fence_class_points[i]["points"].toFixed(1)}
          </a>
        </td>
      );
    }
    if (this.state.points_data.us_flag) {
      array.push(
        <td className='center-align'>
          <a>
            {entry.total_over_fences_points == 0
              ? "-"
              : entry.total_over_fences_points.toFixed(1)}
          </a>
        </td>
      );
      for (var i = 0; i < entry.under_saddle_class_points.length; i++) {
        array.push(
          <td className='center-align'>
            <a>
              {entry.under_saddle_class_points[i]["points"] == 0
                ? "-"
                : entry.under_saddle_class_points[i]["points"].toFixed(1)}
            </a>
          </td>
        );
      }
    }
    return array;
  };

  getVideosList(class_id, uuid) {
    var class_trips = this.state.videos_list.find(
      (v) => v.class_id == class_id
    );
    if (class_trips) {
      var trip = class_trips.videos.find((v) => v.uuid == uuid);
      if (trip) {
        var videos = trip.videos;
        return videos;
      }
    }
    return [];
  }

  render() {
    const loading = this.state.loading;
    var current_tab = this.state.current_tab;

    if (loading) {
      return null;
    }

    return (
      <div className="section-to-print">
          <section className="search-area">
        <h2 className='sgl-h2'>
          {this.state.division.name} - {this.state.show_name}
        </h2>
        <div className='credit-text'> {process.env.REACT_APP_CREDIT_TEXT}{" "} <a onClick={() => window.open(`https://www.showgroundslive.com`, '_blank', 'noopener,noreferrer')}> {process.env.REACT_APP_CREDIT_COMPANY} </a> </div>
        <br />
        <div className='section-tab tab sgl-mb-5'>
          <button
            className={
              current_tab === "placings"
                ? ["tablinks", "active"].join(" ")
                : "tablinks"
            }
            onClick={this.openTab("placings")}>
            Placings
          </button>
          <button
            className={
              current_tab === "points"
                ? ["tablinks", "active"].join(" ")
                : "tablinks"
            }
            onClick={this.openTab("points")}>
            Points
          </button>
        </div>

        {this.state.entries.map((entry, index) => {
          return (
            <h4 key={index}>
              <span className='sponsor_text'>{entry.type}: </span>
              <Link
                to={
                  "/entries/detail?eid=" +
                  entry.entry_id +
                  "&sid=" +
                  this.getQueryVariable("sid")
                }>
                {entry.entry_number} - {entry.horse}
              </Link>
            </h4>
          );
        })}

        <div
          id='placings'
          className={
            current_tab === "placings"
              ? ["tabcontent", "display_block"].join(" ")
              : ["tabcontent", "display_none"].join(" ")
          }>
          {this.state.classes.length > 0 ? (
            this.state.classes.map((div_class, index) => {
              const trips = div_class.trips.length;
              let result_trips = [...div_class.trips]
              return (
                <div key={index} className='details'>
                  <h2 className='sgl-h2'>
                    <Link
                      to={
                        "/classes/detail?cid=" +
                        div_class.class.class_id +
                        "&sid=" +
                        this.getQueryVariable("sid")
                      }>
                      Class {div_class.class.number} - {div_class.class.name}
                    </Link>
                  </h2>
                  {div_class.jumper_table_info &&
                  div_class.class.class_type == "Jumpers" ? (
                    <p className='jumper-p'>
                      <span className='grid-heading class_jumper_table'>
                        {div_class.jumper_table_info.jumper_table}
                      </span>
                    </p>
                  ) : (
                    <p className='jumper-p'>
                      <span className='grid-heading class_jumper_table'>
                        {div_class.class_related_data.hunter_type}
                      </span>
                    </p>
                  )}
                  {div_class.class.sponsor && (
                    <h3 className='sponsor_text'>
                      Sponsored By: {div_class.class.sponsor}
                    </h3>
                  )}
                  {div_class.class_related_data.judges_count > 0 && (
                    <p className='sponsor_text'>
                      Judges: {this.getJudges(div_class)}
                    </p>
                  )}
                  {trips > 0 ? (
                    <div className='details classescss'>
                      <div
                        id='Results'
                        className={["tabcontent", "display_block"].join(" ")}>
                        <ClassResult
                          callby={"division"}
                          class_details={div_class.class}
                          related_data={div_class.class_related_data}
                          current_show={this.state.current_show}
                          trips={div_class.trips}
                          flag_img_dir={this.state.flag_img_dir}
                          videos_list={this.state.videos_list}
                          jumper_table_info={div_class.jumper_table_info}
                          playing_video={this.state.playing_video}
                          openSection={this.openSection}
                          getVideosList={this.getVideosList}
                          playVideo={this.playVideo}
                          getVideoTitle={this.getVideoTitle}
                          format_currancy={this.format_currancy}
                          getFaultTime={this.getFaultTime}
                          closeModal={this.closeModal}
                          closeSubscriptionModal={this.closeSubscriptionModal}
                          playVideoAfterSubscribe={this.playVideoAfterSubscribe}
                          VideoSubscriptionElement={
                            this.VideoSubscriptionElement
                          }
                          VideoPlayerElement={this.VideoPlayerElement}
                          is_open_play_video_modal={
                            this.state.is_open_play_video_modal
                          }
                          is_open_do_subscription_modal={
                            this.state.is_open_do_subscription_modal
                          }
                          video_to_play={this.state.video_to_play}
                          is_admin={this.state.is_admin}
                          team_scoring_result={div_class.team_scoring_result}
                          result_trips={result_trips}
                        />{" "}
                      </div>
                    </div>
                  ) : (
                    <div>There are currently no entries in this class</div>
                  )}
                </div>
              );
            })
          ) : (
            <div>No classes found in this division.</div>
          )}
        </div>
        <div
          id='points'
          className={
            current_tab === "points"
              ? ["tabcontent", "display_block"].join(" ")
              : ["tabcontent", "display_none"].join(" ")
          }>
          {this.state.points_data.entry_points_array.length > 0 ? (
            <div className='div-responsive'>
              <table className='table table-striped table-hover table-responsive'>
                <thead className='points-header'>
                  <tr className='sgl-primary-header'>
                    <th>Entry </th>
                    {this.getHeadUsingForLoop(
                      this.state.points_data.entry_points_array[0]
                    )}
                    <th className='center-align' style={{ min_width: "30px" }}>
                      Total
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {this.state.points_data.entry_points_array.map(
                    (entry, index) => {
                      return (
                        <tr key={index} className='sgl-anchor'>
                          <td>
                            <Link
                              to={
                                "/entries/detail?eid=" +
                                entry.entry_id +
                                "&sid=" +
                                this.getQueryVariable("sid")
                              }>
                              {entry.entry_number} - {entry.horse}
                            </Link>
                          </td>
                          {this.getPointsDataUsingForLoop(entry)}

                          <td className='center-align'>
                            <a>{entry.total_entry_points.toFixed(1)}</a>
                          </td>
                        </tr>
                      );
                    }
                  )}
                </tbody>
              </table>
            </div>
          ) : (
            <table>
              <tbody>
                <tr>
                  <td>No classes found in this division.</td>
                </tr>
              </tbody>
            </table>
          )}
        </div>
        <div className='copyright-text'>
          {" "}
          {process.env.REACT_APP_COPYRIGHT_TEXT}
        </div>
        </section>
      </div>
    );
  }
}

ResultDetail.contextType = SglContext;
